import React from 'react';
import { Box, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';

function FixedIcons() {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        left: 20,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Phone Icon */}
      <IconButton
        href='tel:+6281286864825'
        target='_blank'
        rel='noopener noreferrer'
        sx={{
          backgroundColor: '#5A9BD4',
          color: '#fff',
          '&:hover': { backgroundColor: '#4682B4' },
        }}
      >
        <PhoneIcon />
      </IconButton>

      {/* WhatsApp Icon */}
      <IconButton
        href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20mau%20tau%20info%20BYD%20nya'
        target='_blank'
        rel='noopener noreferrer'
        sx={{
          backgroundColor: '#25D366',
          color: '#fff',
          '&:hover': { backgroundColor: '#1EBE54' },
        }}
      >
        <WhatsAppIcon />
      </IconButton>

      {/* Email Icon */}
      <IconButton
        href='mailto:Juniushukky@gmail.com?subject=Info%20BYD&body=Halo%20saya%20ingin%20tanya%20tentang%20BYD'
        sx={{
          backgroundColor: '#EA4335',
          color: '#fff',
          '&:hover': { backgroundColor: '#C62828' },
        }}
      >
        <EmailIcon />
      </IconButton>
    </Box>
  );
}

export default FixedIcons;
